import { lighten } from "polished"
import { css } from "styled-components"

// Custom focus styles for buttons.

export const buttonFocus = css`
  // Chrome and FireFox render outline differently, FireFox respects border-radius but Chrome does not.
  // To standardize across browsers, we override browser user-agent outline and use box-shadow instead.

  // Removes focus ring for mouse users, but preserves for keyboard users (Chrome only)
  &:focus:not(:focus-visible) {
    outline: none;
  }

  &:focus-visible {
    outline: none !important;
    box-shadow: 0 0 0 3px
      ${(props) => lighten(0.2, props.theme.button.bgColor)};
  }

  // For most buttons, we change the background color or text color when clicked
  // We do not want the default outline to show up on click.
  &:active {
    outline: none;
    box-shadow: none;
  }
`

// For use on buttons with background color
export const buttonDisabled = css`
  &:disabled {
    opacity: 0.7;
    pointer-events: none;
    cursor: default;
  }
`
